/* eslint-disable no-case-declarations */
import {
  SET_CNC_ACTIVATED_COLS,
  NOTIFY_LOOKAHEAD_UPDATE_CNC,
  NOTIFY_LOOKAHEAD_UPDATE_GROUP_CNC,
  NOTIFY_LOOKAHEAD_UPDATE_FILTER_CNC,
  NOTIFY_LOOKAHEAD_UPDATE_ORDER_CNC
} from '../actions/cncActions';

/**
 * Reducer function means a switch case to filter action data on the platform for general state
 * @param {*} state Real time updated through all components state (general state flux)
 * @param {*} action Action is an object with structyure { type: STRING, payload: FUNCTION }
 */
function cncReducer(
  state = {
    activatedColumns: [],
    notifyChange: false,
    notifyChangeGroup: false,
    notifyChangeFilter: false,
    notifyChangeOrder: false
  },
  action
) {
  switch (action.type) {
    case SET_CNC_ACTIVATED_COLS:
      return {
        ...state,
        activatedColumns: action.payload
      };
    case NOTIFY_LOOKAHEAD_UPDATE_CNC:
      return {
        ...state,
        notifyChange: !state.notifyChange
      };
    case NOTIFY_LOOKAHEAD_UPDATE_GROUP_CNC:
      return {
        ...state,
        notifyChangeGroup: !state.notifyChangeGroup
      };
    case NOTIFY_LOOKAHEAD_UPDATE_FILTER_CNC:
      return {
        ...state,
        notifyChangeFilter: !state.notifyChangeFilter
      };
    case NOTIFY_LOOKAHEAD_UPDATE_ORDER_CNC:
      return {
        ...state,
        notifyChangeOrder: !state.notifyChangeOrder
      };
    default:
      return state;
  }
}

export default cncReducer;
